export default __webpack_public_path__ + "static/media/Bird3.1e8cfb6a.png";